import { StateConfigState } from "./types";

export const getDefaultStateConfig = (): StateConfigState => ({});
